export default {
    pages: {
        325: [
            {
                id: 'list', // text_node.
                attributes: [
                    {
                        /* text_node was being hidden under an image_node on this page */
                        name: 'zIndexOverride',
                        value: '2'
                    },
                ]
            },
        ],
    }
};



// WEBPACK FOOTER //
// ./src/js/transformers/MO.EPM.3.1.1.js